import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { Link } from 'dibs-elements/exports/Link';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';
import { trackArticleClick } from './tracking';

import styles from './styles/ArticleLink.scss';

const WORDPRESS_THUMB = 95;
const WORDPRESS_MEDIUM = 276;
const WORDPRESS_FULL = 768;
const getHeaderId = (index: number): string => `wp-article-header-${index}`;
const getDescriptionId = (index: number): string => `wp-article-description-${index}`;

import { ArticleLink_article } from './__generated__/ArticleLink_article.graphql';

type Props = {
    article: ArticleLink_article;
    index: number;
};

const ArticleLink: FC<Props> = props => {
    const { article, index } = props;
    const descriptionId = getDescriptionId(index);
    return (
        <HeadingLevel>
            {Heading => (
                <Link
                    ariaLabel={`Read more about ${article.title}`}
                    ariaDescribedBy={`${getHeaderId(index)},${descriptionId}`}
                    buyerLinkType="standardLinkNoEffect"
                    underline="none"
                    href={article.link}
                    target="_blank"
                    dataTn={`wp-article-link-${index}`}
                    className={styles.article}
                    onClick={() => trackArticleClick(article)}
                >
                    <div className={styles.articleElement}>
                        <img
                            className={styles.featuredImg}
                            src={article.imageUrl.thumb}
                            srcSet={`
                                ${article.imageUrl.thumb} ${WORDPRESS_THUMB}w,
                                ${article.imageUrl.medium} ${WORDPRESS_MEDIUM}w,
                                ${article.imageUrl.full} ${WORDPRESS_FULL}w
                            `}
                            sizes="(max-width: 320px) 100vw, 25vw"
                            alt={article.title}
                        />
                    </div>
                    <div className={styles.articleElement}>
                        <Heading
                            className={styles.header}
                            id={getHeaderId(index)}
                            dangerouslySetInnerHTML={{ __html: article.title }}
                        />
                        <p
                            className={styles.body}
                            id={descriptionId}
                            dangerouslySetInnerHTML={{
                                __html: article.subtitle,
                            }}
                        />
                    </div>
                </Link>
            )}
        </HeadingLevel>
    );
};

export default createFragmentContainer(ArticleLink, {
    article: graphql`
        fragment ArticleLink_article on WordpressArticleType {
            title
            imageUrl {
                thumb
                medium
                full
            }
            subtitle
            link
            source
        }
    `,
});
